/**
 * @license
 * Copyright (c) Dominic Carretto
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/trimox/angular-mdc-web/blob/master/LICENSE
 */
import { Component, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, ElementRef, Input, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Platform } from '@angular/cdk/platform';
import { MDCComponent } from '@angular-mdc/web/base';
import { MDCFadingTabIndicatorFoundation, MDCSlidingTabIndicatorFoundation } from '@material/tab-indicator';

/**
 * @fileoverview added by tsickle
 * Generated from: tab-indicator/tab-indicator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/platform';
import * as ɵngcc2 from '@angular/common';

const _c0 = ["content"];
const _c1 = ["mdcTabIndicator", ""];
function MdcTabIndicator_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.icon);
} }
class MdcTabIndicator extends MDCComponent {
    /**
     * @param {?} _platform
     * @param {?} _changeDetectorRef
     * @param {?} elementRef
     */
    constructor(_platform, _changeDetectorRef, elementRef) {
        super(elementRef);
        this._platform = _platform;
        this._changeDetectorRef = _changeDetectorRef;
        this.elementRef = elementRef;
        this._isFoundationInit = false;
        this._active = false;
        this._fade = false;
        this._icon = null;
    }
    /**
     * @return {?}
     */
    get active() { return this._active; }
    /**
     * @param {?} value
     * @return {?}
     */
    set active(value) {
        /** @type {?} */
        const newValue = coerceBooleanProperty(value);
        if (this._active !== newValue) {
            this._active = coerceBooleanProperty(newValue);
            this._active ? this.activate(this.computeContentClientRect()) : this.deactivate();
        }
    }
    /**
     * @return {?}
     */
    get fade() { return this._fade; }
    /**
     * @param {?} value
     * @return {?}
     */
    set fade(value) {
        /** @type {?} */
        const newValue = coerceBooleanProperty(value);
        if (newValue !== this._fade) {
            this._fade = newValue;
            this._initFoundation();
        }
    }
    /**
     * @return {?}
     */
    get icon() { return this._icon; }
    /**
     * @param {?} value
     * @return {?}
     */
    set icon(value) {
        this._icon = value;
        this._updateContentClasses();
    }
    /**
     * @return {?}
     */
    getDefaultFoundation() {
        /** @type {?} */
        const adapter = {
            addClass: (/**
             * @param {?} className
             * @return {?}
             */
            (className) => this._getHostElement().classList.add(className)),
            removeClass: (/**
             * @param {?} className
             * @return {?}
             */
            (className) => this._getHostElement().classList.remove(className)),
            computeContentClientRect: (/**
             * @return {?}
             */
            () => {
                if (!this._platform.isBrowser) {
                    return { height: 0, width: 0, bottom: 0, top: 0, left: 0, right: 0 };
                }
                return this.content.nativeElement.getBoundingClientRect();
            }),
            setContentStyleProperty: (/**
             * @param {?} propName
             * @param {?} value
             * @return {?}
             */
            (propName, value) => this.content.nativeElement.style.setProperty(propName, value))
        };
        return this._fade ? new MDCFadingTabIndicatorFoundation(adapter) : new MDCSlidingTabIndicatorFoundation(adapter);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (!this._isFoundationInit) {
            this._initFoundation();
            this._updateContentClasses();
        }
    }
    /**
     * @param {?} previousIndicatorClientRect
     * @return {?}
     */
    activate(previousIndicatorClientRect) {
        if (this._foundation) {
            this._foundation.activate(previousIndicatorClientRect);
        }
    }
    /**
     * @return {?}
     */
    deactivate() {
        if (this._foundation) {
            this._foundation.deactivate();
        }
    }
    /**
     * @return {?}
     */
    computeContentClientRect() {
        return this._foundation.computeContentClientRect();
    }
    /**
     * @private
     * @return {?}
     */
    _initFoundation() {
        this._foundation.init();
        this._isFoundationInit = true;
        this._changeDetectorRef.markForCheck();
    }
    /**
     * @private
     * @return {?}
     */
    _updateContentClasses() {
        this.content.nativeElement.classList.remove('mdc-tab-indicator__content--underline');
        this.content.nativeElement.classList.remove('mdc-tab-indicator__content--icon');
        if (this.icon) {
            this.content.nativeElement.classList.add('mdc-tab-indicator__content--icon');
            this.content.nativeElement.classList.add('material-icons');
        }
        else {
            this.content.nativeElement.classList.add('mdc-tab-indicator__content--underline');
        }
        this._changeDetectorRef.markForCheck();
    }
    /**
     * Retrieves the DOM element of the component host.
     * @private
     * @return {?}
     */
    _getHostElement() {
        return this.elementRef.nativeElement;
    }
}
MdcTabIndicator.ɵfac = function MdcTabIndicator_Factory(t) { return new (t || MdcTabIndicator)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Platform), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTabIndicator.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MdcTabIndicator, selectors: [["", "mdcTabIndicator", ""], ["mdc-tab-indicator"]], viewQuery: function MdcTabIndicator_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, hostAttrs: [1, "mdc-tab-indicator"], hostVars: 4, hostBindings: function MdcTabIndicator_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-tab-indicator--active", ctx.active)("mdc-tab-indicator--fade", ctx.fade);
    } }, inputs: { active: "active", fade: "fade", icon: "icon" }, exportAs: ["mdcTabIndicator"], features: [ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c1, decls: 3, vars: 1, consts: [[1, "mdc-tab-indicator__content"], ["content", ""], [4, "ngIf"]], template: function MdcTabIndicator_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0, 1);
        ɵngcc0.ɵɵtemplate(2, MdcTabIndicator_ng_container_2_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
MdcTabIndicator.ctorParameters = () => [
    { type: Platform },
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
MdcTabIndicator.propDecorators = {
    active: [{ type: Input }],
    fade: [{ type: Input }],
    icon: [{ type: Input }],
    content: [{ type: ViewChild, args: ['content', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabIndicator, [{
        type: Component,
        args: [{ selector: '[mdcTabIndicator], mdc-tab-indicator',
                exportAs: 'mdcTabIndicator',
                host: {
                    'class': 'mdc-tab-indicator',
                    '[class.mdc-tab-indicator--active]': 'active',
                    '[class.mdc-tab-indicator--fade]': 'fade'
                },
                template: `
  <span #content class="mdc-tab-indicator__content">
    <ng-container *ngIf="icon">{{icon}}</ng-container>
  </span>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None }]
    }], function () { return [{ type: ɵngcc1.Platform }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { active: [{
            type: Input
        }], fade: [{
            type: Input
        }], icon: [{
            type: Input
        }], content: [{
            type: ViewChild,
            args: ['content', { static: true }]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: tab-indicator/module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MdcTabIndicatorModule {
}
MdcTabIndicatorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MdcTabIndicatorModule });
MdcTabIndicatorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MdcTabIndicatorModule_Factory(t) { return new (t || MdcTabIndicatorModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MdcTabIndicatorModule, { declarations: function () { return [MdcTabIndicator]; }, imports: function () { return [CommonModule]; }, exports: function () { return [MdcTabIndicator]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabIndicatorModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [MdcTabIndicator],
                declarations: [MdcTabIndicator]
            }]
    }], null, null); })();

export { MdcTabIndicator, MdcTabIndicatorModule };

//# sourceMappingURL=tab-indicator.js.map